function initCircleGsapSection(section) {
    let inner = section.querySelector(".inner");

    if (window.innerWidth < inner.offsetWidth) {
        let width = window.innerWidth - inner.offsetWidth;

        let header = document.querySelector("sticky-header");
        let height = header.offsetHeight;
        let anchors = document.querySelector(".section-anchor-menu");
        if (anchors) {
            height += anchors.offsetHeight;
        }

        section.style.height = parseInt(window.innerHeight - height) + "px";

        setTimeout(function () {
            gsap.timeline({
                scrollTrigger: {
                    pin: true,
                    trigger: section,
                    start: "top " + height + "px",
                    end: () => `$+=${-width * 1.5}`,
                    invalidateOnRefresh: true,
                },
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top " + height + "px",
                    end: () => `$+=${-width * 1.5}`,
                    scrub: true,
                },
            }).to(inner, {
                x: width + "px",
            });
        }, 20);
    }
}
